const C = {
  name: "PosTerminalGrowth",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
    <path d="M8 22H2C0.9 22 0 22.9 0 24V28V30V34C0 35.1 0.9 36 2 36H8C9.1 36 10 35.1 10 34V30V28V24C10 22.9 9.1 22 8 22ZM8 34H3C2.45 34 2 33.55 2 33V30H7C7.55 30 8 30.45 8 31V34ZM2 27V24H7C7.55 24 8 24.45 8 25V28H3C2.45 28 2 27.55 2 27Z" />
    <path d="M8 38H2C1.45 38 1 38.45 1 39C1 39.55 1.45 40 2 40H8C8.55 40 9 39.55 9 39C9 38.45 8.55 38 8 38Z" />
    <path d="M23 11H17C15.9 11 15 11.9 15 13V28V30V34C15 35.1 15.9 36 17 36H23C24.1 36 25 35.1 25 34V30V28V13C25 11.9 24.1 11 23 11ZM23 34H18C17.45 34 17 33.55 17 33V30H22C22.55 30 23 30.45 23 31V34ZM17 27V13H22C22.55 13 23 13.45 23 14V28H18C17.45 28 17 27.55 17 27Z" />
    <path d="M38 0H32C30.9 0 30 0.9 30 2V28V30V34C30 35.1 30.9 36 32 36H38C39.1 36 40 35.1 40 34V30V28V2C40 0.9 39.1 0 38 0ZM38 34H33C32.45 34 32 33.55 32 33V30H37C37.55 30 38 30.45 38 31V34ZM32 27V2H37C37.55 2 38 2.45 38 3V28H33C32.45 28 32 27.55 32 27Z" />
    <path d="M23 38H17C16.45 38 16 38.45 16 39C16 39.55 16.45 40 17 40H23C23.55 40 24 39.55 24 39C24 38.45 23.55 38 23 38Z" />
    <path d="M38 38H32C31.45 38 31 38.45 31 39C31 39.55 31.45 40 32 40H38C38.55 40 39 39.55 39 39C39 38.45 38.55 38 38 38Z" />
    <path d="M5 33C5.55228 33 6 32.5523 6 32C6 31.4477 5.55228 31 5 31C4.44772 31 4 31.4477 4 32C4 32.5523 4.44772 33 5 33Z" />
    <path d="M20 33C20.5523 33 21 32.5523 21 32C21 31.4477 20.5523 31 20 31C19.4477 31 19 31.4477 19 32C19 32.5523 19.4477 33 20 33Z" />
    <path d="M35 33C35.5523 33 36 32.5523 36 32C36 31.4477 35.5523 31 35 31C34.4477 31 34 31.4477 34 32C34 32.5523 34.4477 33 35 33Z" />
    </g>
  `
};
export {
  C as PosTerminalGrowth
};
